import { useEffect, useState } from 'react';

// Returns true if simplr-web is in the foreground tab of a non-minimized window; otherwise, returns false.
export const usePageVisibility = () => {
  const [isVisible, setIsVisible] = useState(getIsDocumentVisible);

  useEffect(() => {
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };

    function onVisibilityChange() {
      const isDocumentVisible = getIsDocumentVisible();
      setIsVisible(isDocumentVisible);
    }
  });

  return isVisible;

  function getIsDocumentVisible() {
    return document.visibilityState === 'visible';
  }
};
